import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

// 성공 사례 데이터
const successStories = [
  {
    id: 1,
    husbandName: '김철수',
    wifeName: '응웬 티 란',
    marriageYear: 2020,
    location: '하노이',
    story: '처음에는 언어 장벽에 대한 걱정도 있었지만, 베트남국제결혼 서비스의 통역 지원과 문화 교육 덕분에 자연스럽게 서로를 이해할 수 있었습니다. 지금은 한국에서 행복하게 살고 있으며 작년에 첫 아이도 태어났습니다. 베트남 가족들과도 자주 연락하고 방문하며 양국의 문화를 존중하는 가정을 이루고 있습니다.',
    testimonial: '정확한 매칭과 세심한 지원 덕분에 제 인생의 가장 큰 행복을 찾았습니다. 감사합니다!',
    image: 'https://images.unsplash.com/photo-1559624989-7b9303bd9792?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 2,
    husbandName: '박진우',
    wifeName: '팜 민 트',
    marriageYear: 2021,
    location: '호치민',
    story: '농사를 짓는 저에게 맞는 파트너를 찾기 어려웠는데, 베트남국제결혼을 통해 시골 생활을 함께할 수 있는 아내를 만났습니다. 민트는 자연을 사랑하고 농사일에도 관심이 많아 함께 농장을 가꾸며 살고 있습니다. 한국어도 빠르게 배워가며 지역 사회에도 잘 적응하고 있습니다.',
    testimonial: '제 생활 방식과 가치관을 이해하고 존중해주는 아내를 만나게 해주셔서 감사합니다. 저희는 매일 행복합니다.',
    image: 'https://images.unsplash.com/photo-1577644887050-5a5c311015ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 3,
    husbandName: '이상호',
    wifeName: '부이 티 홍',
    marriageYear: 2019,
    location: '다낭',
    story: '재혼을 고민하던 중 베트남국제결혼 서비스를 알게 되었습니다. 첫 만남부터 티 홍의 밝은 미소와 따뜻한 마음에 반했고, 서로의 과거를 이해하고 존중하며 새로운 가정을 꾸리게 되었습니다. 지금은 작은 카페를 함께 운영하며 행복한 생활을 이어가고 있습니다.',
    testimonial: '인생의 두 번째 기회를 준 베트남국제결혼에 진심으로 감사드립니다. 저희는 서로의 지원군이 되어 행복한 나날을 보내고 있습니다.',
    image: 'https://images.unsplash.com/photo-1542343633-ce3256f2183e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 4,
    husbandName: '정민수',
    wifeName: '응웬 타이 안',
    marriageYear: 2022,
    location: '하이퐁',
    story: '회사 운영에 집중하느라 결혼이 늦어졌습니다. 베트남국제결혼을 통해 타이 안을 만나고 나서야 인생에서 정말 중요한 것이 무엇인지 깨달았습니다. 서로 다른 문화와 언어에도 불구하고 깊은 이해와 존중을 바탕으로 행복한 가정을 이루고 있습니다.',
    testimonial: '바쁜 일정에도 불구하고 완벽한 매칭과 만남을 주선해주신 덕분에 행복한 결혼 생활을 시작할 수 있었습니다.',
    image: 'https://images.unsplash.com/photo-1532228143649-7487376b9325?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 5,
    husbandName: '최동훈',
    wifeName: '레 티 짱',
    marriageYear: 2021,
    location: '나트랑',
    story: '40대 후반에 처음으로 결혼을 결심했습니다. 베트남국제결혼 서비스를 통해 짱을 만나 생애 첫 사랑과 결혼을 경험하게 되었습니다. 서로의 문화적 차이를 이해하고 배려하며 매일 새로운 행복을 발견하고 있습니다.',
    testimonial: '늦은 나이에도 진정한 사랑과 가정을 꾸릴 수 있게 도와주셔서 감사합니다. 매일이 축복입니다.',
    image: 'https://images.unsplash.com/photo-1484221268911-471b6a8976e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 6,
    husbandName: '윤재혁',
    wifeName: '판 티 투이',
    marriageYear: 2020,
    location: '후에',
    story: '한국에서 20년간 요리사로 일하면서 결혼에 대한 꿈을 미뤄왔습니다. 베트남국제결혼을 통해 요리에 관심이 많은 투이를 만나 지금은 함께 작은 한식당을 운영하고 있습니다. 서로의 요리 문화를 배우고 발전시키는 과정이 행복합니다.',
    testimonial: '같은 꿈을 공유할 수 있는 파트너를 만나게 해주셔서 감사합니다. 저희의 음식처럼 사랑도 날로 풍미가 깊어집니다.',
    image: 'https://images.unsplash.com/photo-1517335868956-3a9fde71c906?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }
];

function SuccessStories() {
  // 페이지네이션 상태
  const [currentPage, setCurrentPage] = useState(1);
  const storiesPerPage = 3;
  
  // 현재 페이지에 표시할 성공 사례들
  const indexOfLastStory = currentPage * storiesPerPage;
  const indexOfFirstStory = indexOfLastStory - storiesPerPage;
  const currentStories = successStories.slice(indexOfFirstStory, indexOfLastStory);
  
  // 페이지 변경 핸들러
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* 히어로 섹션 */}
      <section className="relative py-16 md:py-20">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" 
            alt="성공적인 국제결혼 커플" 
            className="w-full h-full object-cover brightness-50"
          />
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              성공 사례
            </h1>
            <p className="text-xl text-white opacity-90">
              베트남국제결혼 서비스를 통해 행복한 가정을 이룬 수많은 커플들의 이야기
            </p>
          </div>
        </div>
      </section>
      
      {/* 통계 섹션 */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">1,200+</div>
                <p className="text-gray-600">성공적인 매칭</p>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">98%</div>
                <p className="text-gray-600">고객 만족도</p>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">15년+</div>
                <p className="text-gray-600">서비스 역사</p>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">95%</div>
                <p className="text-gray-600">결혼 유지율</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* 성공 사례 섹션 */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                행복한 커플들의 이야기
              </h2>
              <p className="text-xl text-gray-600">
                서로 다른 문화와 언어를 뛰어넘어 행복한 가정을 이룬 커플들의 진솔한 이야기를 만나보세요.
              </p>
            </div>
            
            <div className="space-y-12">
              {currentStories.map((story, index) => (
                <div 
                  key={story.id} 
                  className={`bg-white rounded-lg shadow-sm overflow-hidden ${
                    index % 2 === 0 ? 'md:flex' : 'md:flex md:flex-row-reverse'
                  }`}
                >
                  <div className="md:w-1/3">
                    <div className="h-64 md:h-full">
                      <img 
                        src={story.image} 
                        alt={`${story.husbandName} & ${story.wifeName}`} 
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  <div className="md:w-2/3 p-6 md:p-8">
                    <div className="flex items-center mb-4">
                      <h3 className="text-xl font-bold text-gray-900">
                        {story.husbandName} & {story.wifeName}
                      </h3>
                      <div className="ml-4 px-3 py-1 bg-secondary-100 text-secondary-800 text-sm font-medium rounded-full">
                        {story.marriageYear}년 결혼
                      </div>
                      <div className="ml-2 px-3 py-1 bg-gray-100 text-gray-600 text-sm font-medium rounded-full">
                        {story.location}
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {story.story}
                    </p>
                    
                    <div className="border-l-4 border-primary-500 pl-4 py-2 bg-primary-50 italic">
                      <p className="text-primary-700">"{story.testimonial}"</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* 페이지네이션 */}
            <div className="mt-12 flex justify-center">
              <nav className="inline-flex rounded-md shadow">
                {Array.from({ length: Math.ceil(successStories.length / storiesPerPage) }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => paginate(index + 1)}
                    className={`px-4 py-2 border ${
                      currentPage === index + 1
                        ? 'bg-primary-600 text-white border-primary-600'
                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                    }`}
                  >
                    {index + 1}
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </section>
      
      {/* 고객 만족도 통계 섹션 */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                고객 만족도
              </h2>
              <p className="text-xl text-gray-600">
                저희 서비스를 이용한 고객들의 만족도는 우리의 자부심입니다
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-primary-100 text-primary-600 mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">소통 만족도</h3>
                <div className="text-3xl font-bold text-primary-600 mb-2">96%</div>
                <p className="text-gray-600">
                  언어 장벽에도 불구하고 원활한 소통을 위한 통역 서비스와 문화 교육에 대한 높은 만족도
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-primary-100 text-primary-600 mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">절차 만족도</h3>
                <div className="text-3xl font-bold text-primary-600 mb-2">98%</div>
                <p className="text-gray-600">
                  비자 절차, 서류 준비, 결혼 등록 등 모든 행정 절차에 대한 투명하고 체계적인 지원
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6 text-center">
                <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-primary-100 text-primary-600 mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">매칭 만족도</h3>
                <div className="text-3xl font-bold text-primary-600 mb-2">95%</div>
                <p className="text-gray-600">
                  개인의 성격, 가치관, 라이프스타일에 맞는 정확한 매칭으로 장기적인 결혼 생활 만족도 보장
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* 콜투액션 섹션 */}
      <section className="py-12 md:py-16 bg-primary-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              여러분의 행복한 이야기도 시작하세요
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              베트남국제결혼 서비스와 함께 새로운 인생을 시작하세요
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/contact" 
                className="px-6 py-3 bg-primary-600 text-white font-medium rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                무료 상담 신청하기
              </Link>
              <Link 
                to="/match" 
                className="px-6 py-3 bg-white text-primary-600 font-medium rounded-md border border-primary-600 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                매칭 서비스 보기
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default SuccessStories; 